// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__oKE32","Spinner":"Loader_Spinner__FS+Og","cssload-spin":"Loader_cssload-spin__MgsdI","Message":"Loader_Message__e3fj3"};